<template>
  <div class=" common-page business-management">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="8">
            <el-form-item label="">
              <el-button type="primary" @click="handleAdd()">添加类型</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :loading="tableOptions.loading"
        :selection="false"
        :show-search-box="false"
        :show-pagination="false">
        <template v-slot:operation="{ row }">
          <span class="operate-btn" @click.stop="handleAddDict(row)">字典管理</span>
          <span class="operate-btn" @click.stop="handleEdit(row)">编辑</span>
          <span class="operate-btn" @click.stop="handleDelete(row.dictTypeId)">删除</span>
        </template>
      </custom-table>
    </div>
    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
    <dict-item ref="dictItem"></dict-item>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEdit from "./addOrEdit.vue";
import dictItem from "./dictItem.vue";
import { deleteInfo, getPage } from "./api";

export default {
  name: "DictManagement",
  components: {
    OperateBox,
    CustomTable,
    addOrEdit,
    dictItem,
  },
  data() {
    return {
      tableData: [],
      tableOptions: {
        loading: false,
      },
      tableColumn: [
        {
          label: "类型名称",
          prop: "dictName",
          show: true,
        },
        {
          label: "类型编号",
          prop: "dictType",
          show: true,
        },
        {
          label: "类型描述",
          prop: "remark",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "250px",
          scopeStatus: true,
          show: true,
        },
      ],
    };
  },

  created() {},
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      this.tableOptions.loading = true;
      getPage()
        .then((res) => {
          this.tableOptions.loading = false;
          if (res.code === 200) {
            this.tableData = res.data;
          }
        })
        .catch(() => {
          this.tableOptions.loading = false;
        });
    },
    handleAdd() {
      this.$refs.addOrEdit.init();
    },
    handleEdit(row) {
      this.$refs.addOrEdit.init(row);
    },
    handleAddDict(row) {
      this.$refs.dictItem.init(row);
    },
    handleDelete(id) {
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        deleteInfo(id).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getTableData();
          } else {
            this.$message.error("删除失败");
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.business-management {
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }
  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }
}
</style>
